export const STORAGE_KEY = 'cookie-consent'
export const VERSION = 1
